<template>
  <div>
    <TemplateDemandConfirmation v-if="isReadyToDraw" :Reservation="Reservation"/>
    <!-- 描画ローディング -->
    <DialogInitialLoading v-else />
  </div>
</template>

<script>
import TemplateDemandConfirmation from "@/views/Templates/Demand/TemplateDemandConfirmation"
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import nativeHandlerService from "@/services/nativeHandler";
import API from "@/API";

import storeJS from "@/store";

window.jcSetDemandReservationInfo = function (reservation) {
  // alert("jcSetDemandReservationInfo:"+JSON.stringify(reservation))
  // alert(JSON.stringify(reservation))
  storeJS.commit("demand/setReservation", reservation);
};

export default {
  name: "confirmation",
  components: {
    TemplateDemandConfirmation,
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();

    const isReadyToDraw = computed(() => {
      return Reservation.value
    })
    const Reservation = computed(() => store.getters["demand/Reservation"]);

    // data_master_bookingservice_id: 1,
    onMounted(async () => {
      if (process.env.ENV === "local") {
        await API.getEbusReservation(route.query.id)
      } else {
        nativeHandlerService.demand.ncDemandReservationID(route.query.id, 1);
        // 現在ネイティブ側から返ってこないので、ここで対応 削除予定
        await API.getDemandToken(1)
        await API.getEbusReservation(route.query.id)
      }
      nativeHandlerService.demand.ncSetDemandIndex(5);
    }); 
    return{
      isReadyToDraw,
      Reservation
    }
  }
};
</script>